"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQtyDiscountByOrderItemMap = void 0;
const domain_1 = require("@oolio-group/domain");
const common_1 = require("../advanceDiscount/common");
/**
 *
 * @param orderItems
 * @param discount
 * @param adjustmentByOrderItemMap
 * @returns This will returns the combinations of orderItems which matches with the discount rule for qty rule
 * In Simple terms it will return items with the matched of discount rule
 */
const setItemsWithMatchedDiscountRule = (items, discount, adjustmentByOrderItemMap) => {
    var _a;
    const { qty: discountQty } = ((_a = discount === null || discount === void 0 ? void 0 : discount.advanceRules) === null || _a === void 0 ? void 0 : _a.purchasedCriteria) || {};
    items.forEach((mainItem, mainIndex) => {
        var _a;
        const matchedItemsPair = [mainItem];
        let matchedItemsQtySum = mainItem.quantity;
        const appliedDiscount = (_a = mainItem.adjustments) === null || _a === void 0 ? void 0 : _a[0];
        if ((0, common_1.isAdvancedDiscountApplicable)(appliedDiscount, discount, mainItem.id, adjustmentByOrderItemMap)) {
            // Check the items quantity value with discount value
            if (mainItem.quantity % discountQty === 0 &&
                !adjustmentByOrderItemMap[mainItem.id]) {
                adjustmentByOrderItemMap[mainItem.id] = { adjustment: discount };
                return;
            }
            // Check the items quantity value with other items quantity by combining it
            items.forEach((subItem, subIndex) => {
                if (mainIndex != subIndex && !adjustmentByOrderItemMap[subItem.id]) {
                    matchedItemsQtySum += subItem.quantity;
                    matchedItemsPair.push(subItem);
                    if (matchedItemsQtySum % discountQty === 0) {
                        matchedItemsPair.forEach(item => {
                            var _a;
                            const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
                            if ((0, common_1.isAdvancedDiscountApplicable)(appliedDiscount, discount, item.id, adjustmentByOrderItemMap)) {
                                adjustmentByOrderItemMap[item.id] = { adjustment: discount };
                            }
                        });
                    }
                }
            });
        }
    });
};
/**
 *
 * @param groupByEntity This will contain groupBy entities object (Entity means category or products)
 * @param discount Highest discount for the items
 * @param adjustmentByOrderItemMap This is object which has info about item level advanced discount
 *  1. Items which is going to have advanced discount
 *  2. Items which is going to be split due to rule mismatched due to item quantity
 *  3. Items where we need to removed the applied discount
 */
const generateQtyDiscountByOrderItemMap = (groupItems, discount, adjustmentByOrderItemMap, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
isManuallyTriggered) => {
    const sortedItems = groupItems.sort((a, b) => {
        if (a.unitPrice === b.unitPrice) {
            return b.quantity - a.quantity;
        }
        else
            return b.unitPrice - a.unitPrice;
    });
    const groupItemsQuantity = sortedItems.reduce((initVal, entity) => {
        var _a;
        const appliedDiscount = (_a = entity.adjustments) === null || _a === void 0 ? void 0 : _a[0];
        initVal.total = (initVal.total || 0) + entity.quantity;
        initVal.applied =
            (appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.id) === discount.id
                ? initVal.applied + entity.quantity
                : initVal.applied;
        return initVal;
    }, { total: 0, applied: 0 });
    const { operator, qty: discountPurchaseQty } = discount.advanceRules.purchasedCriteria || {};
    const isQtyInvalidForRule = groupItemsQuantity.total < discountPurchaseQty;
    const isExactQtyRuleMatching = groupItemsQuantity.total % discountPurchaseQty === 0;
    const isMoreThenQtyMatching = groupItemsQuantity.total >= discountPurchaseQty;
    /**
     * If item quantity is matching the rule or become it invalid
     * Ex: Buy Sandwich and get 10 % off for exact 3 qty:
     *   => Now whether products become 3 or we're reducing product below then 3
     */
    if (isExactQtyRuleMatching || isQtyInvalidForRule) {
        sortedItems.forEach(item => {
            var _a;
            const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
            if (discount.discountRuleType ===
                domain_1.DiscountRuleType.PRODUCT_CATEGORY_QTY_RULE &&
                isExactQtyRuleMatching &&
                (0, common_1.isAdvancedDiscountApplicable)(appliedDiscount, discount, item.id, adjustmentByOrderItemMap)) {
                adjustmentByOrderItemMap[item.id] = {
                    adjustment: {
                        ...discount,
                        quantity: (0, common_1.getDiscountQuantity)(discount, item.quantity),
                    },
                };
            }
            if (isQtyInvalidForRule &&
                appliedDiscount &&
                appliedDiscount.id === discount.id &&
                !adjustmentByOrderItemMap[item.id]) {
                adjustmentByOrderItemMap[item.id] = { adjustment: undefined };
            }
        });
    }
    /**
     * More then condition, we need to update discount quantity for flat discount
     */
    if (operator === domain_1.DiscountOperator.MORE_THAN && isMoreThenQtyMatching) {
        sortedItems.forEach(item => {
            var _a;
            const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
            if ((0, common_1.isAdvancedDiscountApplicable)(appliedDiscount, discount, item.id, adjustmentByOrderItemMap)) {
                adjustmentByOrderItemMap[item.id] = {
                    adjustment: {
                        ...discount,
                        quantity: (0, common_1.getDiscountQuantity)(discount, item.quantity),
                    },
                };
            }
        });
    }
    if (!isExactQtyRuleMatching &&
        !isQtyInvalidForRule &&
        operator === domain_1.DiscountOperator.EXACTLY) {
        /**
         * When products qty count is more then what we define or less then of multiplier of defined qty
         * Ex: Buy Sandwich and get 10 % off for exact 3 qty
         * Case 1: Operator try to add more then desired qty for instance they are adding
         *    4 qty so in this case just add discount for 3 qty
         * Case 2: They are added 6 qty before but now they're reducing it by 1 which become 5 qty overall
         *
         * Here we're going to either Split the item or Removed the added discount to match the rule
         */
        const appliedDiscountItems = [];
        const nonAppliedDiscountItems = [];
        let appliedDiscountQty = 0, nonAppliedDiscountQty = 0, remainingQtyToApply = 0;
        sortedItems.forEach(item => {
            var _a;
            const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
            if (appliedDiscount &&
                (appliedDiscount.id === discount.id ||
                    !appliedDiscount.isDiscountRuleEnabled)) {
                appliedDiscountItems.push(item);
                appliedDiscountQty += item.quantity;
            }
            else {
                nonAppliedDiscountItems.push(item);
                nonAppliedDiscountQty += item.quantity;
            }
        });
        remainingQtyToApply = discountPurchaseQty - appliedDiscountQty;
        /**
         * appliedDiscountQty: If we want to remove or split discount from added discount then we performing thing from here
         * Ex: Buy Sandwich and get 10 % off for exact 3 qty
         * Case 1: We've added 3 qty for Sandwich and now we're increasing its quantity then it should split
         * Case 2: We've added 3 qty for Sandwich for 2 time(total 6 qty) and now we're decreasing its quantity from
         *         one of the item then it should remove existing discount from item
         */
        if ((appliedDiscountItems === null || appliedDiscountItems === void 0 ? void 0 : appliedDiscountItems.length) &&
            appliedDiscountQty > discountPurchaseQty &&
            appliedDiscountQty % discountPurchaseQty !== 0) {
            let splitQty = appliedDiscountQty % discountPurchaseQty;
            const itemsToRemoveDiscount = appliedDiscountItems.filter(item => {
                if (item.quantity / discountPurchaseQty < 1) {
                    const remainQty = splitQty - item.quantity;
                    if (remainQty >= 0) {
                        splitQty = remainQty;
                        return true;
                    }
                }
            });
            if (itemsToRemoveDiscount === null || itemsToRemoveDiscount === void 0 ? void 0 : itemsToRemoveDiscount.length) {
                itemsToRemoveDiscount.forEach(item => {
                    var _a;
                    const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
                    if (!adjustmentByOrderItemMap[item.id] &&
                        appliedDiscount &&
                        appliedDiscount.id === discount.id) {
                        adjustmentByOrderItemMap[item.id] = {
                            adjustment: undefined,
                        };
                    }
                });
            }
            else {
                adjustmentByOrderItemMap[appliedDiscountItems[0].id] = {
                    splitQty,
                };
            }
        }
        else if ((nonAppliedDiscountItems === null || nonAppliedDiscountItems === void 0 ? void 0 : nonAppliedDiscountItems.length) &&
            (nonAppliedDiscountQty > discountPurchaseQty || remainingQtyToApply > 0)) {
            /**
             * Remove the discount if we've more qty then required but less qualified product
             */
            if (groupItemsQuantity.total > discountPurchaseQty &&
                groupItemsQuantity.applied &&
                groupItemsQuantity.applied < discountPurchaseQty) {
                appliedDiscountItems.forEach(i => (adjustmentByOrderItemMap[i.id] = { adjustment: undefined }));
                return;
            }
            /**
             * nonAppliedDiscountItems: If we want to remove or split discount from item where we haven't added
             *                          any discount yet
             * Ex: Buy Sandwich and get 10 % off for exact 3 qty
             * Case 1: We've adding 4 qty from cart then it should split it into 2 part
             *      1. 3 qty where we need to apply discount
             *      2. 1 qty where we don't need to apply discount
             */
            const splitQty = nonAppliedDiscountQty > discountPurchaseQty
                ? nonAppliedDiscountQty % discountPurchaseQty
                : 0;
            const highestNonAppliedDiscountItems = nonAppliedDiscountItems.reduce((initialItem, currItem) => currItem.quantity > (initialItem === null || initialItem === void 0 ? void 0 : initialItem.quantity) ? currItem : initialItem);
            if (highestNonAppliedDiscountItems &&
                highestNonAppliedDiscountItems.quantity > discountPurchaseQty &&
                highestNonAppliedDiscountItems.quantity % discountPurchaseQty !== 0) {
                adjustmentByOrderItemMap[highestNonAppliedDiscountItems.id] = {
                    splitQty,
                };
            }
            /**
             * Here we're getting combined discount across multiple items
             * Ex: Buy 3 Coffee category and get 10% off for Exact 3 qty
             * Whenever the summation of coffee category become 3 or multiplier of 3 then we're adding the discount in cart
             */
            setItemsWithMatchedDiscountRule(nonAppliedDiscountItems, discount, adjustmentByOrderItemMap);
            /**
             * We need to split the item if we'discount rule satisfy by combining the items
             * Ex: Buy 3 sandwich get 10% off for Exact 3 qty
             * There is 2 item added to cart 1. Sandwich with 2 qty and 2. another sandwich with 2 qty
             * So now if we want to apply discount on 3 qty then we need to split the 1 qty from item
             */
            const splitItem = nonAppliedDiscountItems.reduce((initialItem, currItem) => {
                if (adjustmentByOrderItemMap[currItem.id]) {
                    return initialItem;
                }
                const totalQuantity = ((initialItem === null || initialItem === void 0 ? void 0 : initialItem.totalQuantity) || 0) + currItem.quantity;
                const splitQty = totalQuantity > discountPurchaseQty
                    ? totalQuantity % discountPurchaseQty
                    : 0;
                if (splitQty &&
                    currItem.quantity > splitQty &&
                    currItem.quantity % discountPurchaseQty !== 0) {
                    nonAppliedDiscountItems.splice(1);
                    return { item: currItem, splitQty, totalQuantity: 0 };
                }
                return { item: currItem, totalQuantity, splitQty: 0 };
            }, {});
            if ((splitItem === null || splitItem === void 0 ? void 0 : splitItem.splitQty) && (splitItem === null || splitItem === void 0 ? void 0 : splitItem.item)) {
                adjustmentByOrderItemMap[splitItem.item.id] = {
                    splitQty: splitItem.splitQty,
                };
            }
        }
    }
};
exports.generateQtyDiscountByOrderItemMap = generateQtyDiscountByOrderItemMap;
//# sourceMappingURL=qtyDiscountHelper.js.map